import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';
import moment from 'moment';
import { getOr } from 'lodash/fp';

const { Cell } = Table;

const SlotAvailableCell = ({ rowData, dataKey, ...props }) => {
  const {
    outreachOn,
    outreachEnd,
    scheduleDuration,
    reservationCount
  } = rowData;
  const startTime = moment(outreachOn).format('X');
  const endTime = moment(outreachEnd).format('X');
  const durationLimit = rowData[dataKey];
  const scheduleCount =
    scheduleDuration > 0
      ? Math.floor((endTime - startTime) / (scheduleDuration * 60))
      : 1;
  const totalSlots = durationLimit * scheduleCount;
  const approvedCount = getOr(0, 'approved', reservationCount);
  const pendingCount = getOr(0, 'pending', reservationCount);
  const availableSlot = totalSlots - (approvedCount + pendingCount);

  return (
    <Cell {...props}>{availableSlot > 0 ? availableSlot : 'No Limit'}</Cell>
  );
};

SlotAvailableCell.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number,
    outreachOn: PropTypes.string,
    outreachEnd: PropTypes.string,
    scheduleDuration: PropTypes.number,
    reservationCount: PropTypes.shape({
      approved: PropTypes.number,
      pending: PropTypes.number
    })
  }),
  dataKey: PropTypes.string.isRequired
};

SlotAvailableCell.defaultProps = {
  rowData: null
};

export default SlotAvailableCell;
